import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsDateString, IsOptional, IsString } from "class-validator";
import SelectItem from "@/models/components/inputs/selectItem";
import { CurrencyItems } from "@/models/api/administration/exchangeRate/CurrencyItems";
import { ServiceTypeIcon } from "./serviceTypes/ServiceTypeIcon";

export class OfficeSettings {
  @IsString({ each: true })
  @Expose()
  allowedBookingFileExtensions!: Array<string>;
  @IsString({ each: true })
  @Expose()
  allowedMailAttachmentFileExtensions!: Array<string>;
  @IsString()
  @Expose()
  userCulture!: string;
  @IsDateString()
  @IsOptional()
  @Expose()
  userSystemDate!: string;
  @IsString()
  @Expose()
  baseCurrency!: string;
  @IsBoolean()
  @Expose()
  isDocumentRequireProjectId!: boolean;
  @IsBoolean()
  @Expose()
  showMailNotificationFunction!: boolean;
  @IsArray()
  @Expose()
  cultures!: Array<SelectItem>;
  @IsArray()
  @Expose()
  @Type(() => CurrencyItems)
  currencies!: Array<CurrencyItems>;
  @IsArray()
  @Expose()
  @Type(() => ServiceTypeIcon)
  serviceTypeIcons!: Array<ServiceTypeIcon>;
  @IsBoolean()
  @Expose()
  hasManyOffices!: boolean;
  @IsBoolean()
  @Expose()
  uncheckBookingAfterExit!: boolean;
}
